module.exports = __webpack_public_path__ + "img/skate-quiz-pair.7e0ea19b.png";